import Vue from 'vue';
import VueRouter from "vue-router";
import store from './store'; // Adjust path to your store

const Home = () => import("./components/HomeComponent");
const Login = () => import("./components/auth/LoginComponent");
const Signup = () => import("./components/auth/SignupComponent");
const ForgetPassword = () => import("./components/auth/ForgetPassword");
const ResetPassword = () => import("./components/auth/ResetPassword");

const Step1 = () => import("./components/steps/Step1");
const Step2 = () => import("./components/steps/Step2");
const Step3 = () => import("./components/steps/Step3");
const Step4 = () => import("./components/steps/Step4");
const Step5 = () => import("./components/steps/Step5");
// const Step6 = () => import("./components/steps/Step6");
const Cart = () => import("./components/steps/Cart");
const Portal = () => import("./components/steps/Portal");




const PageNotFound = () => import("./pages/404");

Vue.use(VueRouter);

const routes = [
    {
        path: "/reservations",
        component: Home,
        name: "Home"

    },
    {
        path: "/reservations/login",
        component: Login,
        name: "Login"
    },
    {
        path: "/reservations/signup",
        component: Signup,
        name: "Signup"
    },
    {
        path: "/reservations/forget-password",
        component: ForgetPassword,
        name: "ForgetPassword"
    },
    {
        path: "/reservations/reset-password/:uid/:token",
        component: ResetPassword,
        name: "ResetPassword",
        props: true,
    },
    {
        path: "/portals/:url_code",
        component: Portal,
        name: "Step1Portal",
        props: true,
    },
    {
        path: "/reservations/step_1",
        component: Step1,
        name: "Step_1"
    },
    {
        path: "/reservations/step1",
        component: Step1,
        name: "Step1"
    },
    {
        path: "/reservations/step2",
        component: Step2,
        name: "Step2"
    },
    {
        path: "/reservations/step3",
        component: Step3,
        name: "Step3"
    },
    {
        path: "/reservations/step4",
        component: Step4,
        name: "Step4"
    },
    {
        path: "/reservations/step5",
        component: Step5,
        name: "Step5"
    },
    // {
    //     path: "/reservations/step6",
    //     component: Step6,
    //     name: "Step6"
    // },

    //--------------------------------------------Admin Routes-----------------------------------//
    { path: "*", component: PageNotFound, name:"404" }

]

const router = new VueRouter({
    mode: "history",
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        window.scrollTo(0, 0);
    },
});

// ...

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    next()
})

router.beforeEach((to, from, next) => {
    store.commit('setPreviousRouteName', from.name);
    next();
});

router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})


function checkAuth(to, from, next, roles = ['admin', 'staff', 'manager']) {
    let user = localStorage.getItem('getUser') && JSON.parse(localStorage.getItem('getUser'));
    if (user && roles.indexOf(user.role) !== -1) {
        next();
    } else {
        localStorage.removeItem('getUser');
        localStorage.removeItem('getAccessToken');
        swal({
            title: "Error!",
            text: "Access Denied",
            // type: "error",
            imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
            showConfirmButton: true
        });
        next({name: 'Login'})
    }
}


export default router;

// export default new VueRouter({routes});
